import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activePurchaseLocation: state.location.activePurchaseLocation,
});

angular
  .module('myConsultApp')
  .controller(
    'purchaseLocationCreateEditController',
    ($ngRedux, $rootScope, $scope, $timeout, $http, ENV) => {
      $scope.initData = () => {
        $scope.currentPurchaseLocation = {
          title: '',
          order: 0,
        };
        $scope.purchaseLocationProcessing = false;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };
        $scope.title = 'ADD PURCHASE LOCATION';
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.applyError = (error) => {
        const errorData = error.data['purchase-location'];
        const details = [];

        Object.keys(errorData).map((key) => {
          if (typeof errorData[key] === 'string') {
            $scope.error.highlightedFields[key] = [errorData[key]];
          } else if (Array.isArray(errorData[key])) {
            $scope.error.highlightedFields[key] = errorData[key];
          } else {
            $scope.error.highlightedFields[key] = Object.values(errorData[key]);
          }
        });

        if (error.status === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (error.status === 400) {
          if (Object.keys($scope.error.highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else if (error.status === 403) {
          details.push('You do not have permission to perform this action.');
        } else {
          details.push(error.statusText);
        }
        $scope.error.details = details;
      };

      $scope.disableEntry = () => {
        if ($scope.currentPurchaseLocation.id) {
          $scope.purchaseLocationProcessing = true;
          $scope
            .disablePurchaseLocation($http, ENV, $scope.currentPurchaseLocation.id)
            .then(() => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.close();
                $rootScope.getData(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.submitPurchaseLocation = () => {
        const payload = {
          'purchase-location': $scope.currentPurchaseLocation,
        };
        const currentPurchaseLocationId = $scope.currentPurchaseLocation.id;
        $scope.purchaseLocationProcessing = true;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };

        if (!$scope.currentPurchaseLocation.id) {
          $scope
            .createPurchaseLocation($http, ENV, payload)
            .then(() => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.close();
                $rootScope.getData();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.applyError(error);
              });
            });
        } else {
          $scope
            .updatePurchaseLocation($http, ENV, currentPurchaseLocationId, payload)
            .then(() => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.close();
                $rootScope.getData(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.purchaseLocationProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.close = () => {
        $scope.setPurchaseLocation(null);
        $rootScope.closeComponent();
      };

      $scope.clearForm = () => {
        if ($scope.purchaseLocationForm) {
          $scope.purchaseLocationForm.$setUntouched();
          $scope.purchaseLocationForm.$setPristine();
        }
      };

      $scope.$watch('activePurchaseLocation', () => {
        if ($scope.activePurchaseLocation) {
          $scope.title = 'EDIT PURCHASE LOCATION';
          $scope.currentPurchaseLocation = angular.copy($scope.activePurchaseLocation);
        } else {
          $scope.initData();
        }
      });

      $scope.$watch('subComponent', (newValue, oldValue) => {
        if (oldValue === 'create-purchase-location' || oldValue === 'edit-purchase-location') {
          $scope.initData();
          $scope.clearForm();
        }
      });

      $scope.init();
      $scope.initData();
      $scope.$on('$destroy', $scope.unsubscribe);
    },
  )
  .directive('purchaseLocationCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/purchase-location-create-edit.html',
    };
  });
